<template>
	<div class="exchangeRecord-user" :style="{ '--height': height, }">
		<div class="index-view-top">
			<van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
			<div class="title">{{ $t("luckyhash.exchange") }}</div>
			<van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
		</div>
		<div class="user-scroll">
			<div class="lucky">
				<div :class="lucky == 1 ? 'click-div' : ''" @click="lucky = 1">
					<span>{{ $t("luckyhash.exchange") }}</span>
				</div>
				<div :class="lucky == 2 ? 'click-div' : ''" @click="lucky = 2">
					<span>{{ $t("exchangeRecord.record") }}</span>
				</div>
			</div>
			<div class="exchangeRecord-main" v-if="lucky == 2">
				<ul class="infinite-list" v-infinite-scroll="load" style="overflow: auto">
					<div v-if="convertRecordslist.length < 1"
						style="padding:  3rem 0;color: #ffffff;text-align: center;">
						{{ $t("transactiondetails.not") }}
					</div>
					<div v-else class="card" v-for="(item, index) in convertRecordslist" :key="index">
						<div class="card-top">{{ item.createTime }}</div>
						<div class="card-center">
							<p>{{ item.consumeNumber }}{{ item.consumeCoin }}</p>
							<p>+{{ item.getNumber }}{{ item.getCoin }}</p>
						</div>
						<div class="card-bottom">{{ $t("exchangeRecord.For_spending") }}</div>
					</div>
				</ul>

			</div>
			<div class="exchangeRecord-main" v-if="lucky == 1">
				<div class="money">
					<div>
						<div class="exchange">
							<span>{{ $t("exchangeRecord.money") }}</span>
							<span>{{ $t("exchangeRecord.exchange_number") }}={{ $t("exchangeRecord.number") }}*{{
									$t("exchangeRecord.market_price")
							}}- {{ $t("exchangeRecord.Miners_fee") }}</span>
						</div>
						<div class="input-exchange">
							<div>
								<input type="text" @input="setNumber" v-model="USDTnumber" :placeholder="tips1" />
							</div>
							<div>
								<img v-if="topCoin == 'USDT'" src="../assets/img/USDT.png">
								<img v-else src="../assets/img/TRX.png">
								<span v-if="topCoin == 'USDT'">USDT</span>
								<span v-else>TRX</span>
							</div>
						</div>
					</div>
					<div class="img-zh" @click="changeTopCoin">
						<img src="../assets/img/zh.png">
					</div>
					<div>
						<div class="exchange">
							<span>{{ $t("exchangeRecord.Get_the_amount") }}</span>
						</div>
						<div class="input-exchange">
							<div>
								<input type="text" :disabled="true" v-model="TRXnumber" :placeholder="tips2" />
							</div>
							<div>
								<img v-if="topCoin != 'USDT'" src="../assets/img/USDT.png">
								<img v-else src="../assets/img/TRX.png">
								<span v-if="topCoin != 'USDT'">USDT</span>
								<span v-else>TRX</span>
							</div>
						</div>
					</div>
					<div class="moneyaddress">{{ $t("exchangeRecord.address") }}：{{ walletAddress }}</div>
					<div class="Immediatelychange" @click="convert">
						<button type="button">{{ $t("exchangeRecord.Immediatelychange") }}</button>
					</div>
				</div>
				<div class="Warm-prompt">
					<!-- <img src="../assets/img/wxts.png"> -->
					<span v-html='articleDetails' style="line-height:20px"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	convertRecords,
	convert, info, article
} from "@/utils/request";
export default {
	data() {
		return {
			current: 1,
			size: 10,
			lucky: 1,
			convertRecordslist: [],
			topCoin: 'TRX',
			USDTnumber: '',
			TRXnumber: '',
			walletAddress: '',//兑换钱包地址
			height: '',//屏幕高度
			changeTimer: '',//计时器
			articleDetails: '',//提现提示
			userInfo: '',
			tips1: this.$t("exchangeRecord.input_money"),//请输入兑换金额
			tips2: this.$t("exchangeRecord.Can_be"),//可获得金额
		};
	},
	//获取屏幕高度
	created() {
		let h = document.documentElement.clientHeight || document.body.clientHeight;
		if (h > 0) {
			this.height = h + 'px' //页面高度
		} else {
			this.height = "100vh"
		}
	},
	mounted() {
		// clearInterval(this.changeTimer)
		// this.convertRecords()
		// this.USDTnumber = '1'
		// this.setNumber()
		// var obj = setInterval(async () => {
		// 	if (window.tronWeb && window.tronWeb.defaultAddress.base58) {
		// 		clearInterval(obj);
		// 		this.walletAddress = window.tronWeb.defaultAddress.base58
		// 	}
		// }, 10);
		this.getArticle()
	},
	methods: {
		//提现提示
		getArticle() {
			info().then((res) => {
				if (res.code == "200") {
					this.userInfo = res.data;
				}
			});
			article({ type: 'TIPS_CONVERT' }).then((res) => {
				if (res.code == "200") {
					this.articleDetails = res.data.content
				}
			});
		},
		convertRecords() {
			var that = this
			that.current = 1
			convertRecords({
				current: that.current,
				size: that.size,
			}).then((res) => {
				if (res.code == "200") {
					that.convertRecordslist = res.data.records
				}
			});
		},
		toBack() {
			this.$router.go(-1);
		},
		load() {
			var that = this
			convertRecords({
				current: that.current + 1,
				size: that.size,
			}).then((res) => {
				if (res.code == "200") {
					if (res.data.records.length > 0) {
						that.current += 1
						that.convertRecordslist = [...that.convertRecordslist, ...res.data.records]
					}

				}
			});
		},
		setNumber() {
			let that = this
			return
			clearInterval(this.changeTimer)
			if (this.topCoin == 'TRX') {

				$.getJSON("../../static/usdt.json", (data) => {
					var obj = setInterval(async () => {
						if (window.tronWeb && window.tronWeb.defaultAddress.base58) {
							clearInterval(obj);
							// const trc20ContractAddress1 = "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t";//contract address
							// let contract1 = await window.tronWeb.contract().at(trc20ContractAddress1);
							// let result = await contract1.name().call();
							// this.$toast.success(result);
							//alert(data)
							tronWeb.trx.getBalance('TDcYnKonZrGKsEWYLyVBdFWEVHzhVCMvYi').then(result => alert(result))
							const trc20ContractAddress = "TQn9Y2khEsLJW1ChVWFMSMeRDow5KcbLSE";//contract address
							let contract = await window.tronWeb.contract(data, trc20ContractAddress);
							//alert(contract)
							let result = await contract.name().call()
							//let result = await contract.getTrxToTokenInputPrice('1000000').call()
							//alert(123)
							return
							const trc20ContractAddress1 = "TQn9Y2khEsLJW1ChVWFMSMeRDow5KcbLSE";//contract address
							let contract1 = await tronWeb.contract(data, trc20ContractAddress);
							//获取trx兑换USDT预估值
							this.changeTimer = setInterval(async () => {
								// console.log()

								//let ree = await contract.getTrxToTokenInputPrice(tronWeb.toSun(this.USDTnumber)).call()
								// console.log(tronWeb.toDecimal(ree))
								contract.getTrxToTokenInputPrice(tronWeb.toSun(this.USDTnumber)).call().then((res) => {
									//console.log(res)
									alert('TRX1')
									that.TRXnumber = tronWeb.toDecimal(res) / 1000000
								}).catch((error) => {
									alert(error)
								})
								//that.TRXnumber = tronWeb.toDecimal(ree) / 1000000
							}, 2000);
						}
					}, 10);
				})
			} else {
				$.getJSON("../../static/usdt.json", (data) => {
					var obj = setInterval(async () => {
						if (window.tronWeb && window.tronWeb.defaultAddress.base58) {
							clearInterval(obj);
							var tronweb = window.tronWeb
							const trc20ContractAddress = "TQn9Y2khEsLJW1ChVWFMSMeRDow5KcbLSE";//contract address
							let contract = await tronWeb.contract(data, trc20ContractAddress);
							//获取USDT兑换trx预估值
							this.changeTimer = setInterval(async () => {
								let resultTrx = await contract.getTokenToTrxInputPrice(tronWeb.toSun(this.USDTnumber)).call()
								that.TRXnumber = tronWeb.toDecimal(resultTrx) / 1000000
							}, 2000);
						}
					}, 10);
				})
			}
		},
		//交换按钮
		changeTopCoin() {
			if (this.topCoin == 'TRX') {
				this.topCoin = 'USDT'
			} else {
				this.topCoin = 'TRX'
			}
		},
		convert() {
			var that = this
			return
			const TronWeb = require("tronweb");
			const HttpProvider = TronWeb.providers.HttpProvider;
			const fullNode = new HttpProvider("https://api.trongrid.io"); //Your local TVM URL
			const solidityNode = new HttpProvider("https://api.trongrid.io");
			const eventServer = "https://api.trongrid.io";
			const privateKey =
				"6d8d7cdc92dbcbe945643efe1a9fcd80d875ea82fbee3460ee0207611d12e1e9";
			const tronWeb = new TronWeb(
				fullNode,
				solidityNode,
				eventServer,
				privateKey
			);
			$.getJSON("../../static/usdt.json", (data) => {
				var obj = setInterval(async () => {
					if (window.tronWeb && window.tronWeb.defaultAddress.base58) {
						clearInterval(obj);
						var tronweb = window.tronWeb
						const trc20ContractAddress = "TQn9Y2khEsLJW1ChVWFMSMeRDow5KcbLSE";//contract address
						let contract = await tronWeb.contract(data, trc20ContractAddress);
						if (this.topCoin == 'TRX') {
							//trx兑换USDT 
							let ree = await contract.trxToTokenSwapInput((this.TRXnumber * 950000), new Date().getTime() + 180000).send({
								callValue: tronWeb.toSun(this.USDTnumber)
							})
							convert({
								txHash: ree,
								consumeCoin: this.topCoin,
								consumeNumber: that.USDTnumber,
								getCoin: "USDT",
								getNumber: that.TRXnumber
							}).then((res) => {
								if (res.code == "200") {
									console.log(res)
								} else {
									this.$toast(res.msg);
								}
							});
						} else {
							//USDT 兑换trx
							let cvtHash = await contract.tokenToTrxSwapInput(tronWeb.toSun(this.USDTnumber), tronWeb.toDecimal(this.TRXnumber * 1000000) - 10000, new Date().getTime() + 180000).send();
							console.log(cvtHash, '交易哈希')
							convert({
								txHash: cvtHash,
								consumeCoin: this.topCoin,
								consumeNumber: that.USDTnumber,
								getCoin: "TRX",
								getNumber: that.TRXnumber
							}).then((res) => {
								if (res.code == "200") {
									console.log(res)
								} else {
									this.$toast(res.msg);
								}
							});
						}
					}
				}, 10);
			});

		},

	},
};
</script>

<style lang="scss" scoped>
.Warm-prompt {
	margin-top: 0.9375rem;
	padding-bottom: 4rem;

	img {
		width: 0.9375rem;
		height: 0.9375rem;
	}

	span {
		font-size: 0.75rem;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
	}
}

.infinite-list {
	height: calc(var(--height) - 6.75rem);
}

.money {
	// height: 292px;
	border-radius: 0.625rem;
	opacity: 1;
	margin-top: 1.25rem;
	padding: 0.9375rem;
	border: 0.0625rem solid #272727;

	.Immediatelychange {
		margin-top: 1.875rem;

		button {
			font-size: 0.9375rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #0C0B0B;
			height: 2.6875rem;
			background: linear-gradient(180deg, #FFDB67 0%, #F8C007 100%);
			border-radius: 1.375rem;
			opacity: 1;
			width: 100%;
		}

	}

	.moneyaddress {
		font-size: 0.75rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #999999;
		margin-top: 0.9375rem;
	}

	.img-zh {
		text-align: center;
		height: 2.3125rem;
		line-height: 4.8125rem;

		img {
			width: 0.9375rem;
			height: 1.3125rem;
		}
	}

	.input-exchange {
		background: #161414;
		border-radius: 0.25rem;
		opacity: 1;
		display: flex;
		justify-content: space-between;
		padding: 0.5rem 0.625rem;
		line-height: 1.5rem;
		margin-top: 0.9375rem;

		input {
			background: none;
			color: #999999;
		}

		img {
			width: 1.6875rem;
			height: 1.6875rem;
		}

		div:nth-child(1) {
			span {
				font-size: 0.8125rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #555555;
			}
		}

		div:nth-child(2) {
			display: flex;

			span {
				font-size: 0.9375rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
				margin-top: 0.1875rem;
				margin-left: 0.3125rem;
			}
		}
	}

	.exchange {
		span:nth-child(1) {
			font-size: 0.875rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #FFFFFF;
		}

		span:nth-child(2) {
			margin-left: 0.625rem;
			font-size: 0.75rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #FF693A;
		}
	}
}

.lucky {
	// height: 39px;
	display: flex;
	justify-content: space-around;
	padding-top: 1.0625rem;

	div {
		width: auto;
		height: 1.4375rem;
	}

	.click-div {
		span {
			font-size: 1rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #f8c007;
		}

		width: auto;
		border-bottom: 0.0625rem solid #f8c007;
		height: 1.4375rem;
	}

	span {
		width: 5rem;
		height: 1.4375rem;
		font-size: 1rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #999999;
	}
}

.exchangeRecord-user {
	width: 100vw;
	height: var(--height);
	overflow-y: scroll;
	overflow-x: hidden;
	background: #0c0b0b;

	.exchangeRecord-main {
		padding: .5rem 0.9375rem 0;

		.card {
			width: 100%;
			background: #161414;
			border-radius: 0.625rem;
			margin-bottom: .9375rem;

			.card-top {
				font-size: 0.6875rem;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
				padding: 0.9375rem 0.9375rem 0.625rem;
			}

			.card-bottom {
				font-size: 0.75rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
				padding: 0 .9375rem .9375rem;
			}

			.card-center {
				display: flex;
				padding: 0 0.9375rem;
				justify-content: space-between;

				>p:nth-child(1) {
					font-size: 0.875rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #ffffff;
				}

				>p:nth-child(2) {
					font-size: 0.875rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #d85158;
				}
			}
		}
	}

	.user-scroll {
		height: calc(var(--height) - 3.625rem);
		overflow-y: scroll;
	}

	.index-view-top {
		height: 3.625rem;
		padding: 0 0.9375rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/user/exchangeRecord.vue